import { Switch as RadixSwitch } from 'radix-ui';
import { forwardRef, type ComponentPropsWithoutRef } from 'react';
import { cn } from '@/lib/utils';

interface SwitchProps extends ComponentPropsWithoutRef<typeof RadixSwitch.Root> {
  label?: string;
}

const Switch = forwardRef<HTMLButtonElement, SwitchProps>(({ label, className, ...props }, ref) => (
  <label className={cn('flex cursor-pointer items-center gap-3', className)}>
    {label ? <span className="text-lg text-white">{label}</span> : null}
    <RadixSwitch.Root
      ref={ref}
      className={cn(
        'relative inline-flex h-5.75 w-9.5 shrink-0 cursor-pointer items-center rounded-full border-[1.5px] border-white/35 bg-[#1b1b1f]',
        'transition-[background,border-color] duration-200',
        'data-[state=checked]:border-brand-orange data-[state=checked]:bg-brand-orange',
        'hover:brightness-110',
        'disabled:cursor-not-allowed disabled:opacity-50'
      )}
      {...props}
    >
      <RadixSwitch.Thumb
        className={cn(
          'pointer-events-none block h-2.75 w-2.75 translate-x-1.5 rounded-full bg-white/55',
          'transition-transform duration-200 will-change-transform',
          'data-[state=checked]:h-4.25 data-[state=checked]:w-4.25 data-[state=checked]:translate-x-8 data-[state=checked]:bg-white'
        )}
      />
    </RadixSwitch.Root>
  </label>
));

Switch.displayName = 'Switch';

export { Switch };
export type { SwitchProps };
